/**
 * BE-153 — `GET /gift/config?currency=` (public): the gift quiz's occasions and budget bands from
 * the published `default-gift-survey` definition, labels in `Accept-Language`, budgets per
 * currency. `ETag` / `Cache-Control` on the wire.
 */
import { apiClient } from '@/api/api'

export interface GiftConfigOccasion {
  key: string
  label: string
}

export interface GiftConfigBudget {
  key: string
  label: string
  min: number | null
  max: number | null
}

export interface GiftConfig {
  occasions: GiftConfigOccasion[]
  /** By ISO-4217 code (`USD`, `EUR`, `GBP`, `RUB`). */
  budgets: Record<string, GiftConfigBudget[]>
  defaultCurrency: string
  /** The ranges are the design's placeholders until the product sets them. */
  placeholderBudgets: boolean
  definitionVersion: number
}

export const getGiftConfig = (currency?: string) =>
  apiClient.get<GiftConfig>('/gift/config', { params: currency ? { currency } : {} })
